import { twMerge } from "tailwind-merge"
import { Icon, IconProps } from "./Icon"

export function Spinner(props: Omit<IconProps, 'name'>) {
  return <Icon name="refresh" className={twMerge("animate-spin", props.className)} {...props}/>
}
